import { FC } from 'react'
import { useRouter } from 'next/router'
import clsx from 'clsx'
import Link from 'next/link'

import CardCategory, {
  defineMaterialType,
} from 'components/cards/card-parts/card-category/card-category'

import { INewslineCard } from 'constants/types/card.types'
import { getPreview } from 'components/cards/newsline-card/utils'
import { MaterialsType } from 'components/cards/card-parts/card-category/constants'
import { cutTxt } from 'utils/cutTxt'
import { Pathname } from 'constants/data'
import { A_art_openArticle, originArticle } from 'utils/analytics/library/article'
import { A_lec_openLectures, originLectures } from 'utils/analytics/library/lectures'
import { A_wp_openWebinar, originPWebinar } from 'utils/analytics/webinars/webinar_past'

import styles from './introCard.module.scss'
import PreviewImage from 'components/cards/newsline-card/preview-image'

export enum TypeIntroCard {
  WEBINAR = 'webinar',
  COMMON = 'common',
}
interface IIntroCard {
  data: INewslineCard
  isMobile?: boolean
  typeCard?: TypeIntroCard
  modWrapper?: string
}
const IntroCard: FC<IIntroCard> = ({
  data,
  isMobile = false,
  typeCard = TypeIntroCard.COMMON,
  modWrapper,
}) => {
  const { basePath } = useRouter()

  const linkCreator = () => {
    const currMaterial = defineMaterialType(data.materialType, data.ArticleTypeId)
    if (currMaterial === MaterialsType.VIDEO) {
      window.open(`/${Pathname.ARTICLE}/${data.linkTranslation || data.id}`, '_ blank')
      A_lec_openLectures(originLectures.LANDING, data.id)
      return
    }

    if (currMaterial === MaterialsType.ARTICLE) {
      window.open(`/${Pathname.ARTICLE}/${data.linkTranslation || data.id}`, '_ blank')
      A_art_openArticle(originArticle.LANDING, data.id)
      return
    }

    if (currMaterial === MaterialsType.PODCAST) {
      window.open(`/${Pathname.PODCAST}/${data.linkTranslation || data.id}`, '_ blank')
      return
    }

    window.open(`/${Pathname.WEBINAR}/${data.linkTranslation || data.id}`, '_ blank')
    A_wp_openWebinar(originPWebinar.LANDING, data.id)
  }

  if (typeCard === TypeIntroCard.WEBINAR) {
    const previewImgData = getPreview(basePath, data.previewName, '', data.materialType, '700')
    return (
      <div onClick={linkCreator} className={styles.link}>
        <PreviewImage {...previewImgData} width="100%" height="auto" alt="Превью материала" />
      </div>
    )
  }

  return (
    <div onClick={linkCreator} className={styles.link}>
      <div className={clsx(styles.wrapper, modWrapper)}>
        <CardCategory materialType={data.materialType} ArticleTypeId={data.ArticleTypeId} />
        <div className={styles.title}>{cutTxt(data.name, 75)}</div>
      </div>
    </div>
  )
}

export default IntroCard
